module.exports = __webpack_public_path__ + "static/media/mareges_vertical.946a4810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mareges_vertical.png
// module id = 1849
// module chunks = 0